// Sous-plan 5 : les adresses de connexion et de deconnexion de la SPA quand elle est construite
// pour une app Astraly (NEXT_PUBLIC_ASTRALY_APP_URL pose au build). Sans cette variable, les
// adresses amont (WorkOS) restent. Lisible cote client : process.env.* est remplace par Vite.

export function astralyAppUrl(): string | null {
  const brut = process.env.NEXT_PUBLIC_ASTRALY_APP_URL;
  const app = typeof brut === "string" ? brut.trim().replace(/\/$/, "") : "";
  return app || null;
}

export function astralyLoginUrl(
  apiBaseUrl: string,
  returnTo: string | null
): string {
  const app = astralyAppUrl();
  if (app) {
    return `${app}/api/dust/chat${
      returnTo ? `?retour=${encodeURIComponent(returnTo)}` : ""
    }`;
  }
  return `${apiBaseUrl}/api/workos/login${
    returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ""
  }`;
}

export function astralyLogoutUrl(apiBaseUrl: string): string {
  return astralyAppUrl()
    ? `${apiBaseUrl}/api/astraly/logout`
    : `${apiBaseUrl}/api/workos/logout`;
}
